import React from 'react'

import { FieldArray } from 'formik'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem1xs2,
    GridItem2,
    GridItem2xs4,
    GridItem3xs4,
    GridItem4,
    GridItem6,
    GridItem8,
    GridItem9,
    GridItem10,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import {
    IconButtonClearEntradaDados,
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    processaRegistrosDefaultIniciaisSimulacaoFinanceiraAporteRetiradaAnual,
} from './SimulacaoFinanceiraServiceAporteRetiradaAnual'

import {
    IdadeInicial,
    IdadeFinal,
    Mes,
    AporteAnual,
    RetiradaAnual,
    Observacao,
} from './SimulacaoFinanceiraCompAporteRetiradaAnual'

import SimulacaoFinanceiraFormAporteRetiradaAnualConfiguracao from './SimulacaoFinanceiraFormAporteRetiradaAnualConfiguracao'



const SimulacaoFinanceiraFormAporteRetiradaAnual = ({ values, handleChange }) => {

    processaRegistrosDefaultIniciaisSimulacaoFinanceiraAporteRetiradaAnual(values)

    const isXsDownScreen = IsXsDownScreen()

    const GridItemObservacao = isXsDownScreen ? GridItem8 : GridItem9

    return (
        <FieldArray name="aporteRetiradaAnual">
            {(arrayHelpers) => (
                <CardGridEntradaDadosHeaderBody
                    title={LABEL.aportesRetiradasAnuaisUnicos}
                >
                    <DivForm>
                        {values.aporteRetiradaAnual?.map((item, ind) => {
                            return (
                                <div
                                    key={ind}
                                >
                                    <GridContainer>
                                        {!isXsDownScreen && (
                                            <GridItem1 />
                                        )}

                                        <GridItem1xs2>
                                            <IdadeInicial
                                                values={values}
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem1xs2>

                                        <GridItem2xs4>
                                            <IdadeFinal
                                                values={values}
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem2xs4>

                                        <GridItem1xs2>
                                            <Mes
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem1xs2>

                                        {isXsDownScreen && (
                                            <GridItem4/>
                                        )}

                                        <GridItem3xs4>
                                            <AporteAnual
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem3xs4>
                                        
                                        <GridItem3xs4>
                                            <RetiradaAnual
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem3xs4>

                                        <GridItem1xs2>
                                            <GridContainer>
                                                <GridItem6>
                                                    <CustomizedDialogsPopup
                                                        maxWidth="md"
                                                        popupTitle={LABEL.aporteAnual+ ' / ' + LABEL.retiradaAnual}
                                                        tooltipTitle={LABEL.expandir}
                                                        PopupButton={IconButtonMaisInformacoes}
                                                        popupButtonDestaque={false}
                                                        popupComponent={
                                                            <SimulacaoFinanceiraFormAporteRetiradaAnualConfiguracao
                                                                values={values}
                                                                ind={ind}
                                                                item={item}
                                                                handleChange={handleChange}
                                                            />
                                                        }
                                                    />
                                                </GridItem6>

                                                <GridItem6>
                                                    <IconButtonClearEntradaDados
                                                        onClick={() =>
                                                            arrayHelpers.remove(ind)
                                                        }
                                                    />
                                                </GridItem6>
                                            </GridContainer>
                                        </GridItem1xs2>
                                    </GridContainer>

                                    {item.observacao && (
                                        <GridContainer>
                                            {!isXsDownScreen && (
                                                <GridItem2 />
                                            )}

                                            <GridItemObservacao>
                                                <Observacao
                                                    item={item}
                                                    ind={ind}
                                                    handleChange={handleChange}
                                                />
                                            </GridItemObservacao>
                                        </GridContainer>
                                    )}
                                </div>
                            )
                        })}

                        
                        <GridContainer>
                            {!isXsDownScreen && (
                                <GridItem1 />
                            )}
                            
                            <GridItem10
                                className={CLASSNAME().helpTextInLine}
                            >
                                {HELPTEXT.simulacaoFinanceiraFormAporteRetiradaAnual}
                            </GridItem10>
                        </GridContainer>
                    </DivForm>

                    <GridContainer>
                        {!isXsDownScreen && (
                            <GridItem1 />
                        )}

                        <GridItem10>
                            <ButtonIncluirLinha
                                align='right'
                                label={LABEL.buttonIncluirAporteRetiradaAnual} 
                                onClick={() => 
                                    arrayHelpers.push({})
                                }
                            />
                        </GridItem10>
                    </GridContainer>
                </CardGridEntradaDadosHeaderBody>
            )}
        </FieldArray>
    )
}

export default SimulacaoFinanceiraFormAporteRetiradaAnual